/**
 * Writes the primitive value.
 * @param target The target to be written.
 * @param value The value to write.
 */
export function writePrimitive(target, value) {
    target.write(value);
}
